/* ============================================================================
   QUICK BUY — the PDP's drawer (1100:87560, ../10-pdp-prototype/drawers.js)
   opened from an Our Core Products card's + (the mobile card, 242:33396),
   in the card's colour. Real wearfigs.com sizes and fits (data/carousel.json);
   the line lands in the lab's shared bag and the bag opens on it.
   V0 opened it from Define Your Uniform (18-new-customer-landing-v0/dyu.js).
   ========================================================================== */

import { addToFigsBag, openFigsBag } from '/src/figs-nav/figs-nav.js';
import { $ } from '../10-pdp-prototype/mo.js';
import { announce } from '../10-pdp-prototype/ui.js';
import { initQuickBuy } from '../10-pdp-prototype/drawers.js';
import { SIZE_NAMES } from '../10-pdp-prototype/data.js';

const FIT = { regular: 'Regular', petite: 'Petite', tall: 'Tall', short: 'Short' };
let quickBuy = null;

function drawer() {
  if (quickBuy) return quickBuy;
  quickBuy = initQuickBuy({
    root: $('[data-drawer="quickbuy"]'),
    onAdd: (prod, sel) => {
      const p = prod.source;
      addToFigsBag({
        id: p.handle, name: p.title, color: p.colorName, size: sel.size, type: sel.type,
        price: p.price, image: p.images[0], fallback: p.images[1] || null, url: p.url,
      }, { open: false }).then(() => announce(`Added ${p.title}, ${p.colorName}, ${SIZE_NAMES[sel.size] || sel.size}, to your bag.`));
    },
    onAdded: () => openFigsBag(),
  });
  return quickBuy;
}

export function openQuickBuy(p, trigger) {
  const sizes = p.sizes?.length ? p.sizes : ['O/S'];
  drawer().open({
    source: p, name: p.title, price: p.price, sizes, url: p.url, color: p.color,
    types: (p.fits?.length ? p.fits : ['regular']).map((f) => FIT[f] || f),
    /* the card's own colour only — the carousel sells that colourway */
    colors: { core: [{ slug: p.color, name: p.colorName, hex: p.hex || '#282828' }], limited: [] },
    gallery: p.images, slideClass: 'ncl-qb__slide',
  }, trigger, { size: sizes.length === 1 ? sizes[0] : null });
}
